<template>
  <q-btn
    v-if="mode === 'list'"
    flat
    round
    size="8px"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :ripple="false"
    icon="engp:engp-ico-registry_outline"
    @click.stop="goToRegistration($event, record)"
  >
    <q-tooltip>Go to registration</q-tooltip>
  </q-btn>
  <WorkflowsBtn
    @showWorkflow="$emit('showWorkflow', $event)"
    :loading="loading"
    :relatedWorkflowStatuses="relatedWorkflowStatuses.find((i) => i.id === record.id)?.statuses || []"
  />
  <q-btn
    v-if="mode === 'edit' && !record.deleted_at"
    flat
    round
    size="12px"
    icon="sym_r_edit"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :loading="loading"
    :disabled="loading || disableEditDnsIds.find((item) => item.id === record?.id)"
    @click="$emit('edit')"
  >
    <q-tooltip v-if="!loading" max-width="480px" style="white-space: pre-line">{{
      !!disableEditDnsIds.find((item) => item.id === record?.id)
        ? disableEditDnsIds.find((item) => item.id === record?.id)?.message
        : 'Edit'
    }}</q-tooltip>
  </q-btn>
  <q-btn
    v-if="mode === 'edit' && !record.deleted_at"
    flat
    round
    size="13px"
    icon="sym_o_compare_arrows"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :loading="loading"
    :disabled="loading || disableReassignDnsIds.find((item) => item.id === record?.id)"
    @click="$emit('reassign')"
  >
    <q-tooltip v-if="!loading" max-width="480px" style="white-space: pre-line">{{
      !!disableReassignDnsIds.find((item) => item.id === record?.id)
        ? disableReassignDnsIds.find((item) => item.id === record?.id)?.message
        : 'Reassign record'
    }}</q-tooltip>
  </q-btn>
  <q-btn
    v-if="mode === 'edit' && !record.deleted_at"
    flat
    round
    size="12px"
    icon="sym_r_delete"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :loading="loading"
    :disabled="loading || disableDeleteDnsIds.find((item) => item.id === record?.id)"
    @click="$emit('remove')"
  >
    <q-tooltip v-if="!loading" max-width="480px" style="white-space: pre-line">{{
      !!disableDeleteDnsIds.find((item) => item.id === record?.id)
        ? disableDeleteDnsIds.find((item) => item.id === record?.id)?.message
        : 'Delete'
    }}</q-tooltip>
  </q-btn>
  <q-btn
    flat
    round
    size="10px"
    style="width: 30px; height: 40px"
    class="btn--no-hover"
    :ripple="false"
    icon="engp:engp-ico-copy"
    @click.stop="copyUuid(record.id)"
  >
    <q-tooltip>Copy uuid</q-tooltip>
  </q-btn>
</template>

<script>
import { copyToClipboard } from 'quasar';
import WorkflowsBtn from '@/shared/components/WorkflowsBtn.vue';
import { supportCntrlClick } from '@/shared/helpers';

export default {
  name: 'ActionsCell',
  components: {
    WorkflowsBtn,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
    },
    disableEditDnsIds: {
      type: Array,
    },
    disableDeleteDnsIds: {
      type: Array,
    },
    disableReassignDnsIds: {
      type: Array,
    },
    mode: {
      type: String,
    },
    relatedWorkflowStatuses: {
      type: Array,
    },
  },
  methods: {
    goToRegistration(event, record) {
      supportCntrlClick(
        event,
        `/my-portfolio/${record.registration?.digitalService?.apmId}/registration/${record.registration.id}?dnsRecordId=${record.id}`,
      );
    },
    copyUuid(uuid) {
      copyToClipboard(uuid).then(() => {
        this.$notify('info', 'Info', 'DNS record UUID was copied');
      });
    },
  },
};
</script>
